export const removeEmptyFields = <T extends Record<string, any>>(data: T) => {
  const _data: any = {};
  Object.keys(data).forEach((key) => {
    if (data[key] === '' || data[key] == null) delete data[key];
    if (data[key] && data[key] !== '') _data[key] = data[key];
  });

  return _data;
};
